import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove external branding elements
const removeBranding = () => {
  const selectors = [
    '[class*="emergent"]',
    '[id*="emergent"]',
    '[data-emergent]',
    'a[href*="emergent"]',
  ];
  
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.style.display = 'none';
      el.remove();
    });
  });
  
  // Remove by text content
  document.querySelectorAll('div, span, a, p').forEach(el => {
    if (el.textContent && el.textContent.includes('Made with') && el.textContent.includes('mergent')) {
      el.style.display = 'none';
      el.remove();
    }
  });
};

// Run on load and observe for dynamic elements
if (typeof window !== 'undefined') {
  window.addEventListener('load', removeBranding);
  setInterval(removeBranding, 1000);
  
  const observer = new MutationObserver(removeBranding);
  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
